import router from "@/router";

export const Manager = (code, target = null) => {
    switch (code) {
        case 401: //token expirado
            return router.push({ name: "login" });
        case 404: //no found
            return (target != null) ?  router.push({ name: target }) : 1;
            break;
        default:
            break;
    }
}

export default { Manager };